export default "__VITE_ASSET__C9qA58l$__"